import { get } from 'lodash/get'
import { handleError } from 'helper/rest'
import { clientPublic , clientPublicService } from 'helper/axios'

export const getResultSubOperation = async ({ level_id, token }) => {
  try {
    return await clientPublic
      .get(`company?level=${3}&level_id=${level_id}&limit=99`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getResultSubOperationV2 = async ({ level_id, token }) => {
  try {
    return await clientPublicService
      .get(`/core/company?level=${3}&level_id=${level_id}&limit=99`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

